import React, { Component } from 'react';
import { CheckBoxField, TextInputField, SelectField } from 'common/components/form_fields';
import partial from 'lodash/partial';
import FileSelector from 'common/components/file_selector';

/*
 * ICA (Independent Contractor Agreement) contract step.
 *
 * @author: Nathan Ozelim <nathan@startupfoundry.com>
*/
export default class Contract extends Component {
  constructor(props) {
    super(props)

    this.handleChange = this.handleChange.bind(this)
    this.handleFileSelected = this.handleFileSelected.bind(this)
  }

  handleFileSelected(file) {
    const reader = new FileReader()
    reader.onloadend = () => {
      this.handleChange('custom_contract', {
        file: reader.result.split(',').pop(),
        filename: file.name,
        description: file.name,
        type: 'ica'
      })
    }
    reader.readAsDataURL(file)
  }

  handleChange(fieldName, value) {
    const currentValue = this.props.input.value || {}
    this.props.input.onChange({...currentValue, [fieldName]: value})
  }

  render () {
    const stepValues = this.props.input.value || {}

    return (
      <div className="pap-contract">
        <div className="form-row">
          <CheckBoxField meta={{}} label="Use crowdspring's Contract"
            input={{
              value: !stepValues.isCustom,
              name: 'isCustom',
              onChange: (v) => this.handleChange('isCustom', !v)
            }}
            description={
              "We'll take care of the details for you and ensure that the winner signs the contract."
            } />

          {!stepValues.isCustom &&
          <div className="contract-info">
            <div className="form-group">
              <a className="sample-contract-link" onClick={this.props.onToggle}>
                View sample contract
              </a>
            </div>

            <TextInputField meta={{}} label="Name of client for contract"
              placeholder="Legal name of company or your full name"
              input={{
                value: stepValues['client_legal_name'],
                name: 'client_legal_name',
                onChange: ({target: {value}}) => this.handleChange('client_legal_name', value)
              }}/>

            <SelectField meta={{}} allowEmpty={true} label="Country" options={this.props.countries}
              input={{
                value: stepValues['client_legal_country'],
                name: 'client_legal_country',
                onChange: ({target: {value}}) => this.handleChange('client_legal_country', value)
              }}/>
          </div>}
        </div>

        {stepValues.isCustom &&
        <div className="custom-contract form-row">
          <div className="form-group">
            <label>Add Your Own Contract</label>
            <p className="description">If you have a contract that you prefer to use, simply add it below.</p>
          </div>

          {stepValues['custom_contract']?
          <div>
            {stepValues['custom_contract'].description}
            <i className="fa fa-trash"
              onClick={() => this.handleChange('custom_contract', undefined)}></i>
          </div>:
          <div className="form-upload-box">
            <FileSelector onValidFileSelected={this.handleFileSelected}
              acceptedFileType="application/pdf"/>
          </div>}
        </div>}
      </div>)
  }
};
